module.exports = __webpack_public_path__ + "assets/empty-chat.svg?v=e47adee5448faaad5b9564335cee18e6";